import type { PortalCustomization } from "@redotech/customer-portal-sdk/rpc/schema/portal-customization/get-portal-customization";

type ButtonVariant = NonNullable<
  NonNullable<PortalCustomization["buttons"]>["primary"]
>;
type InputFields = NonNullable<PortalCustomization["inputFields"]>;
type Buttons = NonNullable<PortalCustomization["buttons"]>;

type ResolveFontFamily = (
  font: string | null | undefined,
) => string | undefined;

export function resolveButtonFonts(
  buttons: Buttons | null | undefined,
  resolveFontFamily: ResolveFontFamily,
): {
  primaryButton: ButtonVariant | undefined;
  secondaryButton: ButtonVariant | undefined;
  tertiaryButton: ButtonVariant | undefined;
} {
  return {
    primaryButton: withResolvedFont(buttons?.primary, resolveFontFamily),
    secondaryButton: withResolvedFont(buttons?.secondary, resolveFontFamily),
    tertiaryButton: withResolvedFont(buttons?.tertiary, resolveFontFamily),
  };
}

export function resolveInputFieldFonts(
  inputFields: InputFields | null | undefined,
  resolveFontFamily: ResolveFontFamily,
): InputFields | undefined {
  const font = resolveFontFamily(inputFields?.style?.font);
  if (!font || !inputFields?.style) return inputFields ?? undefined;
  return { ...inputFields, style: { ...inputFields.style, font } };
}

function withResolvedFont(
  variant: ButtonVariant | null | undefined,
  resolveFontFamily: ResolveFontFamily,
): ButtonVariant | undefined {
  const font = resolveFontFamily(variant?.style?.font);
  if (!font || !variant?.style) return variant ?? undefined;
  return { ...variant, style: { ...variant.style, font } };
}
